import { i18nMark } from 'lingui-react';

import buildEnum from 'utils/buildEnum';

export const selectorTypes = buildEnum(['customer', 'domicile']);

export const selectorConfig = {
  [selectorTypes.customer]: {
    label: i18nMark('Fleet'),
    optionalLabel: i18nMark('Fleet (Optional)'),
    placeholder: i18nMark('Search by fleet details...'),
    invalid: i18nMark('Select an existing fleet.'),
  },
  [selectorTypes.domicile]: {
    label: i18nMark('Domicile'),
    optionalLabel: i18nMark('Domicile (Optional)'),
    placeholder: i18nMark('Search by fleet details...'),
    invalid: i18nMark('Select an existing fleet.'),
  },
};



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/CustomerInput/Selector/constants.js